import angular from 'angular';

class DocrepoInvoiceJsonCtrl {
    $onInit() {
        let vm = this;
        vm.jsonPretty = JSON.stringify(vm.json, null, 3);
    }
}

angular.module('app.docrepo_invoice').component('docrepoInvoiceJson', {
    templateUrl: require('./json.html'),
    controller: DocrepoInvoiceJsonCtrl,
    bindings: {
        json: '<' // Json de la facture
    }
});
